<template>
  <div class="ak-nav-contnet">
    <div class="ak-nav-contnet-nav">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-vertical-demo"
        mode="vertical"
        @select="handleSelect"
        background-color="#303133"
        text-color="#fff"
        active-text-color="#ffd04b"
      >
        <el-submenu index="1">
          <template slot="title">
            <label class="el-icon-s-cooperation nav-icon"></label>
            <label style="font-size: 16px;" class="nav-icon"
              >运维工具</label
            ></template
          >
          <el-menu-item index="1-1" id="task">创建维护任务</el-menu-item>
          <el-menu-item index="1-2">维护任务列表</el-menu-item>
          <el-menu-item index="1-3">APP日志列表</el-menu-item>
          <el-menu-item index="1-4">设备告警通道</el-menu-item>
          <el-menu-item index="1-5">设备动作监控</el-menu-item>
          <el-menu-item index="1-6">设备动作上报文件</el-menu-item>
          <el-menu-item index="1-7">设备MAC与UUID</el-menu-item>
          <el-menu-item index="1-8">设备实时日志</el-menu-item>
          <el-menu-item index="1-9">查看设备配置</el-menu-item>
          <el-menu-item index="1-10">设备离线authcode查询</el-menu-item>
        </el-submenu>

        <el-submenu index="6">
          <template slot="title">
            <label class="el-icon-menu nav-icon"></label>
            <label style="font-size: 16px;" class="nav-icon"
              >设备软件包管理</label
            ></template
          >
          <el-menu-item index="6-1">软件包自动上传</el-menu-item>
          <el-menu-item index="6-2">软件包自动上传Admin</el-menu-item>
          <!-- <el-menu-item index="6-3">软件包手动上传</el-menu-item> -->
          <el-menu-item index="6-4">云平台发布API</el-menu-item>
          <el-menu-item index="6-5">存储区域</el-menu-item>
        </el-submenu>

        <el-submenu index="2">
            <template slot="title">
            <label class="el-icon-menu nav-icon"></label>
            <label style="font-size: 16px;" class="nav-icon"
              >维修设备管理</label
            ></template>
          <el-menu-item index="2-1">维修设备MAC</el-menu-item>
          <el-menu-item index="2-2">设备authcode追溯</el-menu-item>
        </el-submenu>

        <el-submenu index="7">
          <template slot="title">
            <label class="el-icon-menu nav-icon"></label>
            <label style="font-size: 16px;" class="nav-icon"
              >设备监控</label
            ></template>
          <el-menu-item index="7-1">监控任务</el-menu-item>
          <el-menu-item index="7-2">监控结果</el-menu-item>
          <el-menu-item index="7-3">监控模板</el-menu-item>
        </el-submenu>

        <el-submenu index="10">
          <template slot="title">
            <label class="el-icon-menu nav-icon"></label>
            <label style="font-size: 16px;" class="nav-icon"
              >设备离线监控</label
            ></template>
          <el-menu-item index="10-1">设备离线监控任务</el-menu-item>
          <el-menu-item index="10-2">设备离线监控结果</el-menu-item>
        </el-submenu>

        <el-submenu index="13" v-if="is_admin">
          <template slot="title">
            <label class="el-icon-menu nav-icon"></label>
            <label style="font-size: 16px;" class="nav-icon">业务数据订阅</label>
          </template>
          <el-menu-item index="13-1">订阅/退订</el-menu-item>
          <el-menu-item index="13-2">订阅者列表</el-menu-item>
          <el-menu-item index="13-3">Dis业务订阅列表</el-menu-item>
        </el-submenu>

        <el-submenu index="12">
          <template slot="title">
            <label class="el-icon-menu nav-icon"></label>
            <label style="font-size: 16px;" class="nav-icon">查询设备信息</label>
          </template>
          <el-menu-item index="12-1">设备数量</el-menu-item>
        </el-submenu>

        <el-submenu index="8">
          <template slot="title">
            <label class="el-icon-menu nav-icon"></label>
            <label style="font-size: 16px;" class="nav-icon">设备机型管理</label>
          </template>
          <el-menu-item index="8-1">设备类型</el-menu-item>
          <el-menu-item index="8-2">设备机型</el-menu-item>
        </el-submenu>

        <el-submenu index="9">
          <template slot="title">
            <label class="el-icon-menu nav-icon"></label>
            <label style="font-size: 16px;" class="nav-icon">设备安全</label>
          </template>
          <el-menu-item index="9-1">密码工具</el-menu-item>
        </el-submenu>

        <el-submenu index="3">
          <template slot="title">
            <label class="el-icon-message-solid  nav-icon"></label>
            <label style="font-size: 16px;" class="nav-icon">告警信息</label>
          </template>
          <el-menu-item index="3-1">设备告警</el-menu-item>
          <el-menu-item index="3-2" @click="statistics">告警数据统计</el-menu-item>
          <el-menu-item index="3-3">APP告警</el-menu-item>
          <el-menu-item index="3-4">告警码配置</el-menu-item>
        </el-submenu>

        <el-submenu index="11">
          <template slot="title">
            <label class="el-icon-menu nav-icon"></label>
            <label style="font-size: 16px;" class="nav-icon"
              >运维API</label
            ></template>
          <el-menu-item index="11-1" v-if="is_admin">云平台环境</el-menu-item>
          <el-menu-item index="11-2" v-if="is_admin">云平台服务器</el-menu-item>
          <el-menu-item index="11-3">运维API地址</el-menu-item>
        </el-submenu>

        <el-submenu index="4" v-if="is_admin">
          <template slot="title">
            <label class="el-icon-s-management  nav-icon"></label>
            <label style="font-size: 16px;" class="nav-icon"
              >权限管理</label
            ></template
          >
          <el-menu-item index="4-1">用户管理</el-menu-item>
          <el-menu-item index="4-2">角色管理</el-menu-item>
          <el-menu-item index="4-3">页面权限管理</el-menu-item>
          <el-menu-item index="4-4">组织架构</el-menu-item>
        </el-submenu>

        <el-submenu index="5" v-if="is_admin">
          <template slot="title">
            <label class="el-icon-s-order  nav-icon"></label>
            <label style="font-size: 16px;" class="nav-icon"
              >系统管理</label
            ></template
          >
          <el-menu-item index="5-1">日志审计</el-menu-item>
          <!-- <el-menu-item index="5-2">系统设置</el-menu-item> -->
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>
<script>
import "@/assets/icon/iconfont.css";
export default {
  components: {},
  data() {
    return {
      index2Router: {
        "1-1": "/createTask",
        "1-2": "/taskList",
        "1-3": "/fileList",
        "1-4": "/alarmChannel",
        "1-5": "/deviceActionInfo",
        "1-6": "/deviceActionFiles",
        "1-7": "/deviceMacUuid",
        "1-8": "/remoteLogDevices",
        "1-9": "/deviceConfig",
        "1-10": "/sreApiDeviceOfflineAuthcode",
        "2-1": "/deviceRecord",
        "2-2": "/deviceAuthCode",
        "3-1": "/alarmRecord",
        "3-3": "/appAlarm",
        "3-4": "/alarmConfiguration",
        "4-1": "/userControl",
        "4-2": "/roleControl",
        "4-3": "/pagePermission",
        "4-4": "/organizational",
        "5-1": "/logAudit",
        "5-2": "/systemSettings",
        "6-1": "/deviceRomAutoUpload",
        "6-2": "/deviceRomAutoUploadAdmin",
        "6-3": "/deviceRomDownload",
        "6-4": "/deviceRomCloudApi",
        "6-5": "/deviceRomStorage",
        "7-1": "/deviceMonitorTasks",
        "7-2": "/deviceMonitorResult",
        "7-3": "/deviceMonitorTemplateItems",
        "8-1": "/deviceTypes",
        "8-2": "/deviceModels",
        "9-1": "/deviceSecurityAuthTool",
        "10-1": "/sreApiDeviceOfflineTask",
        "10-2": "/sreApiDeviceOfflineResult",
        "11-1": "/cloudEnv",
        "11-2": "/cloudServer",
        "11-3": "/sreApiUrl",
        "12-1": "/sreApiDeviceCount",
        "13-1": "/subscriberSubscribe",
        "13-2": "/subscriber",
        "13-3": "/subscriberBusinessReportDis",
      },
      router2Index: {
        createTask: "1-1",
        taskList: "1-2",
        fileList: "1-3",
        alarmChannel: "1-4",
        deviceActionInfo: "1-5",
        deviceActionFiles: "1-6",
        deviceMacUuid: "1-7",
        remoteLogDevices: "1-8",
        deviceConfig: "1-9",
        deviceRecord: "2-1",
        deviceAuthCode: "2-2",
        alarmRecord: "3-1",
        appAlarm: "3-3",
        alarmConfiguration: "3-4",
        userControl: "4-1",
        roleControl: "4-2",
        pagePermission: "4-3",
        organizational: "4-4",
        logAudit: "5-1",
        systemSettings: "5-2",
        deviceRomAutoUpload: "6-1",
        deviceRomAutoUploadAdmin: "6-2",
        deviceRomDownload: "6-3",
        deviceRomCloudApi: "6-4",
        deviceRomStorage: "6-5",
        deviceMonitorTasks: "7-1",
        deviceMonitorResult: "7-2",
        deviceMonitorTemplateItems: "7-3",
        deviceTypes: "8-1",
        deviceModels: "8-2",
        deviceSecurityAuthTool: "9-1",
        sreApiDeviceOfflineTask: "10-1",
        sreApiDeviceOfflineResult: "10-2",
        sreApiDeviceOfflineAuthcode: "1-10",
        cloudEnv: "11-1",
        cloudServer: "11-2",
        sreApiUrl: "11-3",
        sreApiDeviceCount: "12-1",
        subscriberSubscribe: "13-1",
        subscriber: "13-2",
        subscriberBusinessReportDis: "13-3",
      },
      userData: {},
      is_admin: false
    };
  },
  mounted() {
    this.is_admin = JSON.parse(localStorage.getItem("is_admin"));
  },
  methods: {
    handleSelect(key) {
      if (key in this.index2Router) this.$router.push(this.index2Router[key]);
    },
    statistics(){
            // window.open("http://120.78.142.208:88/d/2lo1ocXMz");
            window.open("http://grafana.akuvox.com/d/2lo1ocXMz");
    }
  },
  computed: {
    activeIndex() {
      return this.router2Index[this.$route.matched[1].name];
    }
  }
};
</script>
<style lang="less">
@navBgColor: #303133;
.ak-nav-contnet {
  background-color: @navBgColor;
  min-width: 250px;
  overflow: auto;
  height: 100%;
  font-size: 30px;
  .ak-nav-contnet-nav {
    background-color: @navBgColor;
  }
}
.nav-icon {
  vertical-align: middle;
}
.el-menu-item {
  font-size: 16px;
}
</style>
